(() => {
  function reveal(root) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver(entries => {
      for (const entry of entries) if (entry.isIntersecting) {
        entry.target.classList.remove('gmm-story-waiting');
        observer.unobserve(entry.target);
      }
    }, {threshold:0.1});
    for (const node of root.querySelectorAll('[data-reveal]')) {
      if (node.getBoundingClientRect().top < window.innerHeight) continue;
      node.classList.add('gmm-story-waiting');
      observer.observe(node);
    }
  }
  document.querySelectorAll('[data-gmm-story]').forEach(reveal);
  document.addEventListener('shopify:section:load',event => event.target.querySelectorAll('[data-gmm-story]').forEach(reveal));
})();
